/** Máscara de campo decimal pt-BR (QA 15/10/2026): só dígitos e UMA vírgula, com no máximo `casas`
 *  casas decimais (as do PIC do legado: V99 = 2, V9(4) = 4). O ponto digitado (teclado numérico)
 *  vira vírgula. `negativo` permite um "-" à frente (tolerâncias, PIC S9(4)V99). */
export function mascaraDecimal(v: string, casas: number, negativo = false): string {
  // com vírgula, o ponto é milhar (colado "1.234,56") e sai; sem vírgula, o ponto é a decimal
  let s = (v.includes(",") ? v.replace(/\./g, "") : v.replace(/\./g, ",")).replace(/[^0-9,-]/g, "");
  const neg = negativo && s.startsWith("-");
  s = s.replace(/-/g, "");
  const i = s.indexOf(",");
  if (i >= 0) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/,/g, "").slice(0, casas);
  return (neg ? "-" : "") + s;
}

/** Valor gravado -> texto de input decimal preenchido pelo sistema (padrão BR, Ricardo 04/11): milhar + no
 *  mínimo 2 casas, sem cortar casas significativas até `casas` (ex.: 1500 -> "1.500,00"; 10,1234 -> "10,1234").
 *  Sempre com vírgula decimal, para a máscara/parse tratarem o ponto como milhar. */
export function decimalParaInput(v: number | null | undefined, casas: number): string {
  const n = Number(v) || 0;
  return new Intl.NumberFormat("pt-BR", { minimumFractionDigits: Math.min(2, casas), maximumFractionDigits: casas }).format(n);
}

/** Texto pt-BR do input -> número. Com vírgula, o ponto é milhar e sai; sem vírgula, o ponto é a decimal. */
export function parseDecimalBR(s: string | null | undefined): number {
  const t = String(s ?? "").trim();
  return Number((t.includes(",") ? t.replace(/\./g, "") : t).replace(",", ".")) || 0;
}
